import { AdmService } from 'src/app/shared/services/adm.service';
import { Compania } from 'src/app/shared/models/compania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, loadData, toFormData } from 'src/app/shared/utils/helpers';
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, startWith, switchMap, tap } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { ListaPrecioCabecera } from 'src/app/shared/models/listaPrecioCabecera';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Moneda } from 'src/app/shared/models/moneda';
import { Pais } from 'src/app/shared/models/pais';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { TerminoPago } from 'src/app/shared/models/terminoPago';
import { PedidoVentaItem } from 'src/app/shared/models/pedidoVentaItem';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { PVService } from 'src/app/shared/services/pv.service';
import { PedidoVentaCabecera } from 'src/app/shared/models/pedidoVentaCabecera';
import { CotizacionCabecera } from 'src/app/shared/models/cotizacionCabecera';
import { CotizacionesService } from 'src/app/shared/services/cotizaciones.service';
import { CotizacionItem } from 'src/app/shared/models/cotizacionItem';
import { Direccion } from 'src/app/shared/models/direccion';

@Component({
  selector: 'app-cotizacion-item-dialog',
  templateUrl: './cotizacion-item-dialog.component.html'
})
export class CotizacionItemDialogComponent {

  mensaje: number = 0;
  itemForm: FormGroup;
  idTipo: number;
  lp: ListaPrecioCabecera;
  item: PedidoVentaItem;
  codigoEdit: number = -1;
  cantidadDisponible = new FormControl(0);
  precioFijo: boolean = false;
  cab: CotizacionCabecera;
  mesAnioStockDisponible: string = "";
  etiquetaStockDisponible: string = "";
  verCantidadDisponible: boolean = true;
  avisoUnidadesPallet: boolean = false;
  mensajeUnidadesPallet: string;


  //#region autocomplete Dirección entrega

  dirEntregasEncontradas: any;
  dirEntregaSeleccionada: Direccion;
  fcAutocompleteDirEntrega = new FormControl('');
  hintDirEntrega: string = ""
  loadingFcAutocompleteDirEntrega = false;
  minLengthTermDirEntrega = 2;

  //#endregion

  constructor(
    private admService: AdmService,
    private configService: ConfigService,
    private cotizacionesService: CotizacionesService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CotizacionItemDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private parametrosService: ParametrosService,
    private productosService: ProductosService,
    private pvService: PVService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {

    this.itemForm = this.fb.group({

      autor: [''],
      cantidad: [1, [Validators.max(this.cantidadDisponible.value)]],
      cultivo: [''],
      descuentoCategoria: [0],
      descuentoDiscrecional: [0],
      fechaCreacion: [new Date()],
      habilitacion: [true],
      idCompania: [''],
      idCultivo: [''],
      idDivision: [''],
      idLote: [''],
      idPais: [''],
      idPlanta: [''],
      idProducto: ['', Validators.required],
      idSalesOrg: [''],
      itemPlanta: [false],
      itemDistribuidor: [false],
      fechaActualizacion: [new Date()],
      fechaCantidadDisponible: [new Date()],
      // calleNroDireccionEntrega: [''],
      // ciudadDireccionEntrega: [''],
      // nombreClienteDireccionEntrega: [''],
      // nroClienteDireccionEntrega: ['', Validators.required],
      // cpDireccionEntrega: [''],
      idTipoOrden: ['12'],
      nroLinea: [0],
      nroPedido: [0],
      porcentajeRecargo: [0],
      precioFinal: [0],
      precioKGL: [0],
      precioUnitarioFinal: [0],
      precioUnitarioLista: [0],
      producto: ['', Validators.required],
      recargo: [0],
      recargoLocal: [0],
      tipoOrden: ['Cotización'],
      total: [0],
      totalDescuento: [0],
      totalLocal: [0],
      totalPrecioKGL: [0],
      unidadesPallet: [0],
      codigo: [0]
    })

    if (data.cab != null) {
      this.cab = data.cab;
    }

  }

  public Validaciones: {
    Cantidad: string,
    PrecioFinal: string
  }

  public Etiquetas: {

    Cantidad: string,
    CantidadDisponible: string,
    IdProducto: string,
    Producto: string,
    PrecioUnitarioLista: string,
    NombreClienteDireccionEntrega: string,
    NroClienteDireccionEntrega: string,
    DireccionEntrega: string,
    CiudadDireccionEntrega: string,
    CalleNroDireccionEntrega: string,
    CPDireccionEntrega: string,
    PrecioUnitarioFinal: string,
    NroLinea: string,
    PrecioFinal: string,
    PrecioKGL: string

  }

  ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Validaciones = {
      Cantidad: this.configService.validaciones.Cantidad,
      PrecioFinal: this.configService.validaciones.PrecioFinal
    }

    this.Etiquetas = {
      CalleNroDireccionEntrega: this.configService.etiquetas.CalleNroDireccionEntrega,
      Cantidad: this.configService.etiquetas.Cantidad,
      CantidadDisponible: this.configService.etiquetas.CantidadDisponible,
      CiudadDireccionEntrega: this.configService.etiquetas.CiudadDireccionEntrega,
      CPDireccionEntrega: this.configService.etiquetas.CPDireccionEntrega,
      IdProducto: this.configService.etiquetas.IdProducto,
      NombreClienteDireccionEntrega: this.configService.etiquetas.NombreClienteDireccionEntrega,
      NroClienteDireccionEntrega: this.configService.etiquetas.NroClienteDireccionEntrega,
      NroLinea: this.configService.etiquetas.NroLinea,
      PrecioFinal: this.configService.etiquetas.PrecioFinal,
      PrecioKGL: this.configService.etiquetas.PrecioKGL,
      PrecioUnitarioFinal: this.configService.etiquetas.PrecioUnitarioFinal,
      PrecioUnitarioLista: this.configService.etiquetas.PrecioUnitarioLista,
      Producto: this.configService.etiquetas.Producto,
      DireccionEntrega: this.configService.etiquetas.DireccionEntrega
    }
    if (this.cab != null) {
      if (this.cab.items.length) {
        loadData(this.itemForm, this.cab.items[0]);
        this.codigoEdit = this.cab.items[0].codigo;
        this.fcAutocompleteDirEntrega.valueChanges
          .pipe(
            startWith(''),
            filter(res => {
              return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermDirEntrega
            }),
            distinctUntilChanged(),
            debounceTime(1000),
            tap(() => {

              this.dirEntregasEncontradas = [];
              this.loadingFcAutocompleteDirEntrega = true;
            }),
            switchMap(value => this.admService.cDireccionesEntregaAutocompleteSearch(this.loggedService.logged.idPais, this.cab.idCompania, this.cab.idSalesOrg, this.cab.nroCliente, value)
              .pipe(
                finalize(() => {
                  this.loadingFcAutocompleteDirEntrega = false
                }),
              )
            )
          )
          .subscribe((data: Direccion[]) => {
            this.dirEntregasEncontradas = data;

          });
        this.cotizacionesService.cCotizacionItem(this.cab.nroClienteDistribuidor, this.cab.idSucursal, this.codigoEdit).subscribe((data: CotizacionItem) => {

          if (data != null) {

            this.itemForm.controls['cantidad'].setValue(data.cantidad);
            this.itemForm.controls['idProducto'].setValue(data.idProducto);
            this.itemForm.controls['nroLinea'].setValue(data.nroLinea);
            this.itemForm.controls['precioFinal'].setValue(data.precioUnitarioFinal);
            this.itemForm.controls['precioKGL'].setValue(data.precioKGL);
            this.itemForm.controls['precioUnitarioFinal'].setValue(data.precioUnitarioFinal);
            this.itemForm.controls['precioUnitarioLista'].setValue(data.precioUnitarioLista);
            this.itemForm.controls['producto'].setValue(data.producto);
            this.itemForm.controls['unidadesPallet'].setValue(data.unidadesPallet);
            this.cantidadDisponible.setValue(data.cantidadDisponible);
            let d: Date = new Date(data.fechaCantidadDisponible);
            this.mesAnioStockDisponible = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1).toString() + "/" + d.getFullYear().toString() : (d.getMonth() + 1).toString() + "/" + d.getFullYear().toString();
            this.itemForm.controls['precioFinal'].setValidators([Validators.min(1), Validators.max(this.itemForm.controls['precioUnitarioFinal'].value)]);
            this.itemForm.controls['precioUnitarioFinal'].updateValueAndValidity();
            this.itemForm.controls['precioUnitarioFinal'].markAsTouched();
            if (data.itemPlanta && !data.entregaAFuturo) {
              this.itemForm.controls['cantidad'].clearValidators();
              this.verCantidadDisponible = false;
            }
            else {
              this.itemForm.controls['cantidad'].setValidators([Validators.required, Validators.min(0.001), Validators.max(this.cantidadDisponible.value)]);
            }
            this.itemForm.controls['cantidad'].updateValueAndValidity();
            this.itemForm.controls['cantidad'].markAsTouched();

            this.etiquetaStockDisponible = data.entregaAFuturo ? this.configService.etiquetas.CantidadDisponibleCuota + " " + this.mesAnioStockDisponible : this.configService.etiquetas.CantidadDisponible + " (Sucursal " + this.cab.sucursal + ")";


          }

        });
      }



    }


  }

  guardarItem() {
    if (this.itemForm.controls['unidadesPallet'].value == 0) {
      this.avisoUnidadesPallet = true
      this.mensajeUnidadesPallet = "No existen Kg/Litros para el producto"
    }
    else {

      const cantidadNum = this.itemForm.controls['cantidad'].value;
      const unidadesPallet = this.itemForm.controls['unidadesPallet'].value
      var esMultiplo =  Math.abs(cantidadNum / unidadesPallet - Math.round(cantidadNum / unidadesPallet)) < 1e-10;
      let valornum = cantidadNum / unidadesPallet
      if (!esMultiplo) {
        this.avisoUnidadesPallet = true;
        valornum = Math.floor(valornum) + 1
        this.mensajeUnidadesPallet = "La cantidad no corresponde a los Kg/Litros (" + unidadesPallet.toString() + "), cantidad sugerida: "
          + parseFloat((unidadesPallet * (valornum - 1)).toFixed(3)).toString() + " ó " 
          + parseFloat((unidadesPallet * valornum).toFixed(3)).toString();
      } else {
        this.avisoUnidadesPallet = false;
      }
    }
    if (!this.avisoUnidadesPallet) {

      this.cab.items = [];
      this.cab.items.push(this.itemForm.value);

      this.cotizacionesService
        .mCotizacionItem(this.cab)
        .subscribe((data: boolean) => {
          this.mensaje = 2;
          this.dialogRef.close();
        });

      }
    }

    // seleccionarDirEntrega(de: any) {
    //   if (de != "-1") {
    //     this.dirEntregaSeleccionada = de;
    //     this.itemForm.controls['calleNroDireccionEntrega'].setValue(this.dirEntregaSeleccionada.calleNro);
    //     this.itemForm.controls['ciudadDireccionEntrega'].setValue(this.dirEntregaSeleccionada.ciudad);
    //     this.itemForm.controls['cpDireccionEntrega'].setValue(this.dirEntregaSeleccionada.codigoPostal);
    //     this.itemForm.controls['nombreClienteDireccionEntrega'].setValue(this.dirEntregaSeleccionada.nombre);
    //     this.itemForm.controls['nroClienteDireccionEntrega'].setValue(this.dirEntregaSeleccionada.nroCliente);

    //   }
    //   else {
    //     this.dirEntregaSeleccionada = null;
    //     this.itemForm.controls['calleNroDireccionEntrega'].reset();
    //     this.itemForm.controls['ciudadDireccionEntrega'].reset();
    //     this.itemForm.controls['cpDireccionEntrega'].reset();
    //     this.itemForm.controls['nombreClienteDireccionEntrega'].reset();
    //     this.itemForm.controls['nroClienteDireccionEntrega'].reset();
    //   }

    // }

    // handleEmptyInputDirEntrega(event: any) {
    //   if (event.target.value === '' || event.target.value.length < this.minLengthTermDirEntrega) {
    //     this.limpiarDirEntrega(false);
    //   }
    // }

    // limpiarDirEntrega(resetFormControl: boolean) {
    //   this.dirEntregasEncontradas = [];
    //   this.seleccionarDirEntrega("-1");
    //   if (resetFormControl) {
    //     this.fcAutocompleteDirEntrega.setValue('');
    //   }

    // }

    // getOptionTextDirEntrega(option) {
    //   if (option != null) {
    //     return option.displayValue;
    //   }
    // }

    checkPrecioFinal() {
      if (this.itemForm.controls['precioFinal'].value == null || (this.itemForm.controls['precioFinal'].value != null && this.itemForm.controls['precioFinal'].value == '')) {
        this.itemForm.controls['precioFinal'].setValue(0);
      }
    }


    isMobileXL() {
      return isMobileXL();
    }

    isMobile() {
      return isMobile();
    }
    isInRole(rol: string): boolean {
      return this.loggedService.isInRole(rol);
    }

  }
